import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlackPushService } from '@notifications/slack/services/slack-push.service';
import { PushService } from '@notifications/services/push.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SlackPushService,
    PushService
  ]
})
export class NotificationsModule { }
